/* eslint-disable import/no-deprecated */
import React, { useContext } from 'react';
import { Typography } from '../Typography';
import { Context } from './Context';
import css from './index.module.scss';

export const Separator: React.FunctionComponent<
  Omit<React.ComponentProps<typeof Typography>, 'children' | 'variant'>
> = props => {
  const { typography, testId } = useContext(Context);
  /**
   * The separator should always be color="neutrals-n7"
   */
  return (
    <Typography
      data-component="InfoListSeparator"
      testId={`${testId}-separator`}
      {...typography}
      color="neutrals-n7"
      className={css.middot}
      {...props}
    >
      &middot;
    </Typography>
  );
};
